<template>
  <app-modal id="modal-signup" hide-footer>
    <span class="bg-sticker star-nude-large d-none d-md-inline-block">
      <img v-lazy="starNudeDarkSticker" :alt="`sticker star`" width="20" height="20" />
    </span>

    <span class="bg-sticker star-mint-large d-none d-md-inline-block">
      <img v-lazy="starMintDarkSticker" :alt="`sticker star mint`" width="18" height="18" />
    </span>

    <span class="bg-sticker star-pink d-none d-md-inline-block">
      <img v-lazy="starPinkDarkSticker" :alt="`sticker star pink`" width="16" height="16" />
    </span>

    <h4 class="text-center mb-0">
      {{ t("Join the Ersties community and discover more!") }}
    </h4>
    <p class="tagline text-center my-2">
      {{ t("Made by Women, with Love.") }}
    </p>

    <div class="signup-form">
      <google-signup-custom :label="t('Sign up with Google')" />
      <div class="separator">
        {{ t("or") }}
      </div>
      <form-signup :redirect-url="modal?.redirectUrl" />
    </div>

    <div class="log-in mt-2">
      {{ t("Have an account?") }}
      <a v-modal.modal-login href="#" class="link-dark link-underline" data-bs-dismiss="modal">{{ t("Log In") }}</a>
    </div>
  </app-modal>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useModalStore } from "@/store/modal";
import AppModal from "@/components/v2/modals/modal";
import FormSignup from "@/components/v2/form-signup";
import GoogleSignupCustom from "@/components/google-signup-custom";
import { useI18n } from "vue-i18n";
import starNudeDarkSticker from "@/assets/v2/images/stickers/star-nude-dark.svg";
import starMintDarkSticker from "@/assets/v2/images/stickers/star-mint-dark.svg";
import starPinkDarkSticker from "@/assets/v2/images/stickers/star-pink-dark.svg";

defineOptions({
  name: "modal-signup",
});

const modalStore = useModalStore();
const modal = computed(() => modalStore.getShownModalById("modal-signup"));
const { t } = useI18n();
</script>

<style lang="scss">
@import "./index.scss";
</style>
